module.exports = __webpack_public_path__ + "img/housing.4f22f3fd.jpg";